module.exports = __webpack_public_path__ + "img/08_DSC7895-min.fa75701a.jpg";